// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"64287cad","137":"eaf148db","398":"7bcf7af6","663":"2012f328","677":"0849bc6b","742":"e6e2117c","836":"53d61226"}[chunkId] + ".chunk.css";
};